module.exports = __webpack_public_path__ + "img/landwirtschaft_teaser.c901a8dd.jpg";